export const colMargins = {
    smMargin: '0 0 56px',
    mdMargin: '0 0 64px',
    lgMargin: '0 0 96px',
};
